import { createSelector } from 'reselect';
import { memoizeWithTokenHelper } from '@mpp/token-helper';

import { getMerchant, getUserMerchantId } from './common';
import { getInstalledOrInProgressProductId } from './products';
import { translationParser } from '../utils';
import { _getPlatforms, translationMapper } from '../platforms';
import { getFeatureConfig } from '@/selectors/featuresConfig';
import { FEATURES } from '@/constants';

const tKeyPrefix = 'products-fe.components.platform_instructions';

export const getMerchantPlatformId = createSelector(getMerchant, ({ platform }) => platform || '');

export const getSelectedPlatform = createSelector(
  _getPlatforms,
  getMerchantPlatformId,
  (platforms, selectedPlatformId) => {
    const platform = platforms.find(p => p.id === selectedPlatformId);
    return platform || {};
  },
);

export const platformProductStepInstructionsTranslator = platformId =>
  createSelector(
    translationParser,
    getInstalledOrInProgressProductId,
    (translationParser, productId) => {
      if (!platformId) {
        return [];
      }
      const tKeyPath = `${tKeyPrefix}.${platformId}_${productId?.replace('_one', '')}`;
      const translations = translationParser(tKeyPath) || [];
      return translationMapper(translations);
    },
  );

export const hasNewIntegrationGuidesAvailable = createSelector(
  getSelectedPlatform,
  getUserMerchantId,
  getFeatureConfig(FEATURES.INTEGRATION_GUIDES_PLATFORMS_DISABLED),
  (selectedPlatform, mid, featureConfig = { platforms: '' }) => {
    const shouldShowOldGuide =
      featureConfig.is_enabled && featureConfig.platforms?.includes(selectedPlatform?.id);

    return memoizeWithTokenHelper(
      tokenHelper =>
        selectedPlatform.newIntegrationGuides &&
        !shouldShowOldGuide &&
        tokenHelper.hasPermissionForMid(mid, 'integration-guides-fe', 'merchant-full'),
    );
  },
);
